import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StudyCalendar } from "./components/StudyCalendar";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StudyCalendar />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        toastOptions={{
          classNames: {
            toast: "bg-background text-foreground border-border shadow-lg",
            description: "text-muted-foreground",
          },
        }}
      />
    </div>
  );
}

export default App;
